exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3nB3XTNNncs0S2CvlvrJUS{font-size:15px!important}html[dir] ._3nB3XTNNncs0S2CvlvrJUS{padding-bottom:8px}", ""]);
// Exports
exports.locals = {
	"header": "_3nB3XTNNncs0S2CvlvrJUS"
};